import { connect } from 'react-redux';
import {
  getNutritionPlan,
  deleteNutritionPlan,
  deleteMeal
} from 'features/nutrition/ducks/nutritionActions';
import { getClients } from 'features/home/ducks/clientActions';
import CustomDialog from 'shared/components/custom-dialog/CustomDialog';
import Loader from 'features/Loader/Loader';
import { confirmAlert } from 'react-confirm-alert';
import React from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import NutritionData from '../NutritionData';
import MealsList from '../MealCreate/MealsList';
import NutritionPlanMenu from './NutritionPlanMenu';
import ByClientList from './ByClientList';

class NutritionPlanDetails extends React.Component {
  constructor(props) {
    super(props);
    this.planId = this.props.match.params.id;
  }

  componentDidMount() {
    this.props.getNutritionPlan(this.planId, this.props.history);
    this.props.getClients();
  }

  handleDeletionConfirming = () => {
    this.props.deleteNutritionPlan(this.planId);
    this.props.history.push('/nutrition');
  };

  handlePlanDeletion = event => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <CustomDialog
            title="Are you sure"
            text="Are you sure you want to delete this plan?"
            cancelText="Cancel"
            confirmText="Delete"
            onClose={onClose}
            handleConfirming={this.handleDeletionConfirming}
          />
        );
      }
    });
  };

  render() {
    const { nutritionPlan, clients, deleteMeal } = this.props;
    if (nutritionPlan && nutritionPlan.currentNutrationLoadingState) {
      return(<Loader/>);
    }
    return (
      nutritionPlan && (
        <div className="plan-details">
          <div className="container">
            <Breadcrumb>
              <Breadcrumb.Item href="/nutrition">Nutrition</Breadcrumb.Item>
              <Breadcrumb.Item active>{nutritionPlan.name}</Breadcrumb.Item>
            </Breadcrumb>

            <div className="page-title">
              <h4>{nutritionPlan.name}</h4>
              <div className="title-action">
                <i
                  className="fas fa-trash trash-icon"
                  onClick={this.handlePlanDeletion}
                ></i>
                <NutritionPlanMenu planId={nutritionPlan.id} />
              </div>
            </div>

            <div className="plan-details-tab">
              <Tab.Container
                defaultActiveKey="allDetails"
                transition={false}
                id="planDetailsTab"
              >
                <Nav className="nav-tabs">
                  <Nav.Item>
                    <Nav.Link eventKey="allDetails">All</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="byClient">By Client</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="allDetails">
                    <NutritionData
                      protein={nutritionPlan.total_protein}
                      carbs={nutritionPlan.total_carbs}
                      fat={nutritionPlan.total_fat}
                      calories={nutritionPlan.total_calories}
                    />
                    {nutritionPlan.meal_items && (
                      <MealsList
                        planId={this.planId}
                        meals={nutritionPlan.meal_items}
                        deleteMeal={deleteMeal}
                        history={this.props.history}
                        plan={nutritionPlan}
                      />
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="byClient">
                    {clients && nutritionPlan.clients_data && (
                      <ByClientList
                        planId={nutritionPlan.id}
                        clientsId={nutritionPlan.clients_id}
                        clients={clients}
                      />
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    nutritionPlan: state.nutritionReducer.currentNutritionPlan,
    clients: state.clientReducer.clients
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNutritionPlan: (planId, history) =>
      dispatch(getNutritionPlan(planId, history)),
    deleteNutritionPlan: planId => dispatch(deleteNutritionPlan(planId)),
    getClients: () => dispatch(getClients()),
    deleteMeal: (plan, index, history) => dispatch(deleteMeal(plan, index, history))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NutritionPlanDetails);
